import React, { useContext, useState } from 'react';

import { PagePropsContext } from '../App';
import Permalink from './Permalink';
import { isDesktop } from '../utils/functions';

const Faqs = () => {
  const { categories, questions, selectedCategory, setSelectedQuestion } = useContext(PagePropsContext);

  const [activeQuestion, setActiveQuestion] = useState(null);

  const handleClick = (question) => {
    if (isDesktop()) {
      setActiveQuestion(activeQuestion === question ? null : question);
      return;
    }
    setSelectedQuestion(question);
  }

  return <div className='faqs'>
    {categories.filter(category => category.parent_category === selectedCategory.id).map(cat => <div key={cat.id} className='faqs__list'>
      <h3 className='faqs__title'>{cat.name}</h3>
      <ul className='faqs__items'>
        {questions.filter(q => q.category === cat.id).sort((a, b) => a.sort - b.sort).map((q, index) => <li key={q.id} className='faqs__item' onClick={() => handleClick(q)}>
          {index + 1}.&ensp;{q.question}
          <div className={'faqs__answer' + (q.id === activeQuestion?.id ? ' answer--show' : '')}>
            <div className='faqs__answer__content' dangerouslySetInnerHTML={{ __html: q.answer }}></div>
            <Permalink question={q} />
          </div>
        </li>)}
      </ul>
    </div>)}
  </div>;
}

export default Faqs;